import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import userReducer from "./user/user.reducer";
import distroReducer from "./distro/distro.reducer";

const persistConfig = {
  key: "authType",
  storage,
  whitelist: ["user", "distro"],
};

const rootReducer = combineReducers({
  user: userReducer,
  distro: distroReducer,
});

export default persistReducer(persistConfig, rootReducer);
